import { defaultAxios } from '@/services';

import type { BusinessUnitAtList } from './types';

const trustpilotService = {
  async createTrustpilotInfo(
    api_key: string,
    api_secret: string,
    workspaceAlias: string,
  ) {
    try {
      const res = await defaultAxios.post(
        `/workspaces/${workspaceAlias}/trustpilot/credential/client-credentials`,
        {
          api_key,
          api_secret,
        },
      );
      return res.data;
    } catch (e) {
      return false;
    }
  },
  async getTrustpilotInfo(alias: string) {
    try {
      const res = await defaultAxios.get(`/workspaces/${alias}/trustpilot/`);
      return res.data;
    } catch (e) {
      return false;
    }
  },
  async importWorkspaceFeedback(
    alias: string,
    startDate: string,
    endDate: string,
  ) {
    try {
      const res = await defaultAxios.post(`/trustpilot/${alias}/import`, {
        start_date: startDate,
        end_date: endDate,
      });
      return res.data;
    } catch (e) {
      return false;
    }
  },
  async deleteTrustpilotInfo(alias: string) {
    try {
      const res = await defaultAxios.delete(`/trustpilot/${alias}`);
      return res.data;
    } catch (e) {
      return false;
    }
  },
  async searchBusinessUnit(
    alias: string,
    keyword: string,
    perPage: number = 5,
    page = 1,
  ): Promise<BusinessUnitAtList[]> {
    try {
      const res = await defaultAxios.get(
        `/trustpilot/${alias}/business-units?keyword=${keyword}&per_page=${perPage}&page=${page}`,
      );
      return res.data;
    } catch (e) {
      throw e;
    }
  },
  async setBusinessUnit(alias: string, units: string[]) {
    try {
      const res = await defaultAxios.patch(
        `/trustpilot/${alias}/business-units`,
        {
          business_unit_ids: units,
        },
      );
      return res.data;
    } catch (e) {
      return false;
    }
  },
};

export default trustpilotService;
